import { Link, useSearch } from 'wouter';
import { describeApiFailure } from '../api/http.ts';
import { useResetPassword } from '../auth/session.ts';
import { PasswordForm } from '../components/forms/PasswordForm.tsx';
import { useDocumentTitle } from '../hooks/use-document-title.ts';
import { AuthBrand } from './AuthBrand.tsx';
import styles from './LoginPage.module.css';

// The page a reset link opens: choose a new password. The token in the
// link is single-use and short-lived; a stale one gets a clear message.

export function ResetPage() {
  const token = new URLSearchParams(useSearch()).get('token') ?? '';
  const reset = useResetPassword();
  useDocumentTitle('Reset password');

  return (
    <main className={styles['page']}>
      <div className={styles['card']}>
        <AuthBrand />
        {token === '' ? (
          <p className={styles['lead']} role="alert">
            This link is missing its token. Open the link from the email again, or ask for a new
            one.
          </p>
        ) : reset.isSuccess ? (
          <p className={styles['lead']} role="status">
            Your password is set. Sign in with it.
          </p>
        ) : (
          <>
            <p className={styles['lead']}>Choose a new password.</p>
            <PasswordForm
              askCurrent={false}
              submitLabel="Set password"
              pending={reset.isPending}
              error={reset.isError ? describeApiFailure(reset.error) : undefined}
              onSubmit={({ next }) => {
                reset.mutate({ token, password: next });
              }}
            />
          </>
        )}
        <p className={styles['foot']}>
          <Link href="/login" className={styles['link']}>
            {reset.isSuccess ? 'Sign in' : 'Back to sign in'}
          </Link>
        </p>
      </div>
    </main>
  );
}
